import { render, staticRenderFns } from "./GHheader.vue?vue&type=template&id=8767d8c8&scoped=true"
import script from "./GHheader.vue?vue&type=script&lang=js"
export * from "./GHheader.vue?vue&type=script&lang=js"
import style0 from "./GHheader.vue?vue&type=style&index=0&id=8767d8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8767d8c8",
  null
  
)

export default component.exports